{
  "Overview": "סקירה",
  "Inbox": "תיבת שיחות",
  "Bookings": "תורים",
  "Contacts": "אנשי קשר",
  "Services & staff": "שירותים וצוות",
  "AI agent": "סוכן AI",
  "Channels": "ערוצים",
  "Campaigns": "קמפיינים",
  "Settings": "הגדרות",
  "All businesses": "כל העסקים",
  "Business": "עסק",
  "Sign out": "התנתקות",
  "Mobile app": "אפליקציה לנייד",
  "Dark mode": "מצב כהה",
  "Light mode": "מצב בהיר",
  "Change language": "החלפת שפה",
  "No business yet": "עדיין אין עסק",
  "Ask your administrator to add you to a business.": "יש לבקש ממנהל המערכת להוסיף אתכם לעסק.",
  "Page not found": "הדף לא נמצא",
  "Back to overview": "חזרה לסקירה",
  "RELAYZA website": "האתר של RELAYZA",
  "AI FRONT DESK": "דלפק קבלה מבוסס AI",
  "Your business.": "העסק שלכם.",
  "Always on.": "תמיד זמין.",
  "Answers every inquiry in seconds, books into your real calendar, sends reminders and follows up, 24/7. Your team steps in whenever a person is needed.": "עונה לכל פנייה תוך שניות, קובע תורים ישירות ביומן האמיתי שלכם, שולח תזכורות ומבצע מעקב, 24/7. הצוות שלכם נכנס לתמונה בכל פעם שדרוש נציג.",
  "WhatsApp, Instagram, Messenger and website chat in one inbox": "וואטסאפ, אינסטגרם, מסנג׳ר וצ׳אט באתר, בתיבת שיחות אחת",
  "Books with live availability from Google or Outlook calendars": "קביעת תורים לפי זמינות בזמן אמת ביומן Google או ביומן Outlook",
  "Reminders that cut no-shows, follow-ups that recover leads": "תזכורות שמצמצמות אי-הגעה, הודעות מעקב שמחזירות לידים",
  "Sign in": "כניסה",
  "Create your business account": "יצירת חשבון לעסק",
  "Your name": "שם מלא",
  "Business name": "שם העסק",
  "Email": "אימייל",
  "Password": "סיסמה",
  "At least 8 characters": "לפחות 8 תווים",
  "Please wait…": "רגע אחד…",
  "Create account": "יצירת חשבון",
  "New here?": "חדשים כאן?",
  "Create an account": "יצירת חשבון",
  "Request early access": "בקשת גישה מוקדמת",
  "Already have an account?": "כבר יש לכם חשבון?",
  "{n}s": "{n} שנ׳",
  "No activity yet. Send a test message from the AI agent page.": "עדיין אין פעילות. אפשר לשלוח הודעת בדיקה מעמוד סוכן ה-AI.",
  "Conversations and bookings per day": "שיחות ותורים לפי יום",
  "{day}: {conversations} conversations, {bookings} bookings": "{day}: {conversations} שיחות, {bookings} תורים",
  "Conversations": "שיחות",
  "{from} → {to}": "{from} עד {to}",
  "Add your services, durations and prices": "הוספת השירותים, משכי הזמן והמחירים שלכם",
  "Teach the agent your FAQs and policies": "הזנת שאלות נפוצות ומדיניות לסוכן",
  "Connect your Google or Outlook calendar": "חיבור יומן Google או יומן Outlook",
  "Reconnect your calendar: it stopped syncing": "חיבור מחדש של היומן: הסנכרון הפסיק",
  "Calendar connected, but no staff member is linked to it yet. Pick a calendar in Services & staff.": "היומן מחובר, אבל עדיין אף איש צוות לא מקושר אליו. בחרו יומן בעמוד שירותים וצוות.",
  "Replace the [bracketed] placeholders in the agent's knowledge and settings": "השלמת החלקים שבסוגריים בידע ובהגדרות של הסוכן",
  "Replace the [bracketed] placeholders the agent would read as facts: {names}": "השלמת החלקים שבסוגריים, שהסוכן יקרא כעובדות: {names}",
  "and {n} more": "ועוד {n}",
  "Connect WhatsApp, or share your Chat Link": "חיבור WhatsApp, או שיתוף הקישור לצ׳אט",
  "Get set up": "צעדים ראשונים",
  "Last 30 days": "30 הימים האחרונים",
  "{n} customer messages": "{n} הודעות מלקוחות",
  "Booked by AI": "תורים שקבע ה-AI",
  "{n} bookings in total": "{n} תורים בסך הכול",
  "Chat → booking": "המרה משיחה לתור",
  "Median first reply": "זמן תגובה ראשונה (חציון)",
  "Arrived after hours": "פניות מחוץ לשעות הפעילות",
  "Inquiries answered while you were closed": "פניות שנענו כשהעסק היה סגור",
  "No-show rate": "שיעור אי-הגעה",
  "Handed to a person": "הועברו לנציג",
  "AI cost": "עלות AI",
  "{n} model calls": "{n} קריאות למודל",
  "Daily activity": "פעילות יומית",
  "Lead funnel": "משפך לידים",
  "By channel": "לפי ערוץ",
  "No conversations yet.": "עדיין אין שיחות.",
  "Forgot password?": "שכחת סיסמה?",
  "Reset your password": "איפוס סיסמה",
  "Enter your email and we'll send you a link to choose a new password.": "הזינו את האימייל שלכם ונשלח קישור לבחירת סיסמה חדשה.",
  "Send reset link": "שליחת קישור לאיפוס",
  "If {email} has an account, a link to choose a new password is on its way. It works once, within an hour.": "אם ל-{email} יש חשבון, קישור לבחירת סיסמה חדשה כבר בדרך. הוא פועל פעם אחת, תוך שעה.",
  "Nothing arrived? Check spam, or ask again in a few minutes.": "לא הגיע? בדקו בתיקיית הספאם, או בקשו שוב בעוד כמה דקות.",
  "Back to sign in": "חזרה לכניסה",
  "Choose a new password": "בחירת סיסמה חדשה",
  "This link is incomplete. Open the link from the email again, or ask for a new one.": "הקישור לא שלם. פתחו שוב את הקישור מהמייל, או בקשו קישור חדש.",
  "Your password is changed. You were signed out everywhere, the app included, so sign in again with the new one.": "הסיסמה הוחלפה. נותקתם מכל המכשירים, כולל האפליקציה, אז התחברו מחדש עם הסיסמה החדשה.",
  "Repeat the new password": "הקלידו שוב את הסיסמה החדשה",
  "The two passwords don't match": "שתי הסיסמאות לא זהות",
  "Save new password": "שמירת הסיסמה החדשה",
  "New password": "סיסמה חדשה",
  "Quick view": "תצוגה מהירה",
  "{n} need attention": "{n} דורשים טיפול"
}
